import { render, staticRenderFns } from "./event_item_dialog.vue?vue&type=template&id=56852b80"
import script from "./event_item_dialog.vue?vue&type=script&lang=js"
export * from "./event_item_dialog.vue?vue&type=script&lang=js"
import style0 from "./event_item_dialog.vue?vue&type=style&index=0&id=56852b80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports